<template>
  <div>
    <div v-if="isImage(attachmentUrl)" class="text-center">
      <img :src="attachmentUrl" class="max-w-xs max-h-xs mx-auto pt-4" />
    </div>
    <div v-if="attachmentUrl" class="text-center">
      <button class="text-center text-red-600 px-2 py-2 hover:underline" @click="removeAttachment">
        Remove Attachment <i class="ml-2 far fa-trash-alt text-red-500" />
      </button>
    </div>
    <div v-if="attachmentError" class="form-error">{{ attachmentError }}</div>
    <label for="attachment" class="block text-sm font-medium text-gray-700">Attachment</label>
    <input
      id="attachment"
      type="file"
      :accept="acceptedFileTypes"
      class="mt-1 block w-full text-sm text-gray-900 bg-gray-50 rounded-md border border-gray-300 cursor-pointer focus:outline-none focus:border-indigo-500 focus:ring-indigo-500"
      @change="handleFileUpload"
    />
  </div>
</template>

<script>
export default {
  props: {
    initialAttachmentUrl: {
      type: String,
      default: null,
    },
    messageType: {
      type: String,
      default: null,
    },
  },
  emits: ['update:attachmentUrl', 'update:attachmentName'],
  data() {
    return {
      attachmentUrl: this.initialAttachmentUrl,
      attachmentName: '',
      attachmentError: '',
    }
  },
  computed: {
    acceptedFileTypes() {
      if (this.messageType === 'email' || this.messageType === 'reminder') {
        return '.jpeg,.jpg,.png,.bmp,.gif,.tiff,.svg,.3gpp,.mp4,.mpeg,.avi,.mp3,.vcf,.zip,.gz,.rtf,.doc,.docx,.pdf,.xls,.xlsx,.txt,.csv,.html,.xml,.json'
      } else {
        return '.jpeg,.jpg,.png,.bmp,.gif,.tiff,.svg,.3gp,.mp4,.mpeg,.avi,.mp3,.vcf,.zip,.gz,.rtf'
      }
    },
  },
  watch: {
    initialAttachmentUrl(newUrl) {
      this.attachmentUrl = newUrl
    },
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0]
      const destination = this.messageType === 'email' || this.messagetype === 'reminder' ? '/email/upload' : '/sms/MmsFileUploadController';

      if (file) {
        const formData = new FormData()
        formData.append('upload', file)

        fetch(destination, {
          method: 'POST',
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.url) {
              this.attachmentUrl = data.url
              this.attachmentName = data.attachmentName
              this.attachmentError = ''
              this.$emit('update:attachmentUrl', this.attachmentUrl)
              this.$emit('update:attachmentName', this.attachmentName)
            } else if (data && data.error) {
              this.attachmentUrl = ''
              this.attachmentName = ''
              this.attachmentError = data.error.message
            } else {
              console.error('Upload failed: No URL returned.')
            }
          })
          .catch((error) => {
            console.error('Upload failed:', error)
          })
      }
    },
    removeAttachment() {
      this.attachmentUrl = null
      this.attachmentName = null
      this.$emit('update:attachmentUrl', this.attachmentUrl)
      this.$emit('update:attachmentName', this.attachmentName)
    },
    isImage(url) {
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i
      return imageExtensions.test(url)
    },
  },
}
</script>
